import { BuilderUI } from "../../../BuilderUI";
import { createBlockRendererMapping } from "../../../BuilderUI/Helpers/blockMappings";
import { BlockRenderer } from "../../../BuilderUI/Renderer/BlockRenderer";
import { blocks } from "../../VisualEmailBuilder/Blocks";
import { GooberContextProvider } from "../../VisualEmailBuilder/Design/GooberContext";
import { EmailFrame } from "../../VisualEmailBuilder/EmailFrame";
import { useBroadcastPreviewContent } from "./useBroadcastPreviewContent";

const components = createBlockRendererMapping(blocks);

export const VisualBuilderPreviewContent = () => {
  const { visualEmailBuilderContent, isLoading } = useBroadcastPreviewContent();

  if (isLoading || !visualEmailBuilderContent) {
    return null;
  }

  return (
    <BuilderUI.Provider
      theme={{
        customColors: {},
        cssVariables: {
          light: {},
          dark: {},
        },
        value: 1,
        name: "default_theme",
      }}
      block={visualEmailBuilderContent.content}
      inlineAttachments={visualEmailBuilderContent.inline_attachments}
      canvasSize="tablet"
    >
      <GooberContextProvider>
        <EmailFrame>
          <BlockRenderer
            components={components}
            block={visualEmailBuilderContent.content}
          />
        </EmailFrame>
      </GooberContextProvider>
    </BuilderUI.Provider>
  );
};
